import Button from '@mui/material/Button';

const naviButtonStyle = {
  marginX: '.3em',
  color: 'white',
  borderColor: 'white',
  '&:hover': {
    color: '#ffeb3b',
    borderColor: '#ffeb3b',
  },
};

export const NavButton: React.FC<{
  label: string;
  isActive: boolean;
  onClick: () => void;
}> = ({ label, isActive, onClick }) => {
  return (
    <Button
      variant="outlined"
      style={isActive ? { backgroundColor: '#ffeb3b', color: '#3b87bd' } : undefined}
      sx={naviButtonStyle}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};
